import React from "react";
import styled from "styled-components";

// Einfacher Container für grundlegendes Layout und Lesbarkeit (kann wiederverwendet werden)
const LegalPageContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.xl};
  max-width: 800px;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  line-height: 1.6;

  h1 {
    margin-bottom: ${({ theme }) => theme.spacing.lg};
  }

  h2 {
    margin-top: ${({ theme }) => theme.spacing.lg};
    margin-bottom: ${({ theme }) => theme.spacing.md};
    color: ${({ theme }) => theme.colors.primary};
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    padding-bottom: ${({ theme }) => theme.spacing.xs};
  }

  h3 {
    margin-top: ${({ theme }) => theme.spacing.md};
    margin-bottom: ${({ theme }) => theme.spacing.sm};
    color: ${({ theme }) => theme.colors.textStrong};
  }

  p,
  ul {
    margin-bottom: ${({ theme }) => theme.spacing.md};
  }

  li {
    margin-bottom: ${({ theme }) => theme.spacing.xs};
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  address {
    font-style: normal;
    margin-bottom: ${({ theme }) => theme.spacing.md};
  }

  strong {
    color: ${({ theme }) => theme.colors.textStrong};
  }
`;

const DatenschutzPage = () => {
  return (
    <LegalPageContainer>
      <h1>Datenschutzerklärung</h1>
      <p>
        <strong>Stand:</strong> 23. April 2025
      </p>
      <p>
        Wir freuen uns über Ihr Interesse an unserer Webanwendung Law-AI. Der
        Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen.
        Nachfolgend informieren wir Sie ausführlich über den Umgang mit Ihren
        Daten.
      </p>

      <h2>1. Verantwortlicher für die Datenverarbeitung</h2>
      <p>
        Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) und
        anderer nationaler Datenschutzgesetze sowie sonstiger
        datenschutzrechtlicher Bestimmungen ist:
      </p>
      <address>
        Joe Koch-Daubrawa
        <br />
        Nestroyplatz 1
        <br />
        1020 Wien
        <br />
        Österreich
        <br />
        E-Mail: jk@phoenixconsulting.at
      </address>

      <h2>2. Ihre Rechte als betroffene Person</h2>
      <p>
        Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden
        personenbezogenen Daten:
      </p>
      <ul>
        <li>
          <strong>Recht auf Auskunft</strong> (Art. 15 DSGVO)
        </li>
        <li>
          <strong>Recht auf Berichtigung</strong> (Art. 16 DSGVO)
        </li>
        <li>
          <strong>Recht auf Löschung</strong> („Recht auf Vergessenwerden“)
          (Art. 17 DSGVO)
        </li>
        <li>
          <strong>Recht auf Einschränkung der Verarbeitung</strong> (Art. 18
          DSGVO)
        </li>
        <li>
          <strong>Recht auf Widerspruch gegen die Verarbeitung</strong> (Art. 21
          DSGVO)
        </li>
        <li>
          <strong>Recht auf Datenübertragbarkeit</strong> (Art. 20 DSGVO)
        </li>
        <li>
          <strong>Recht auf Widerruf einer erteilten Einwilligung</strong> (Art.
          7 Abs. 3 DSGVO), falls die Verarbeitung auf einer Einwilligung beruht.
        </li>
      </ul>
      <p>
        Zur Ausübung dieser Rechte sowie bei Fragen zum Datenschutz wenden Sie
        sich bitte an die oben genannte Kontaktadresse
        (jk@phoenixconsulting.at).
      </p>
      <p>
        Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde
        über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu
        beschweren (Art. 77 DSGVO). Die zuständige Aufsichtsbehörde in
        Österreich ist die Datenschutzbehörde (Wickenburggasse 8, 1080 Wien,{" "}
        <a
          href="https://www.dsb.gv.at"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.dsb.gv.at
        </a>
        ).
      </p>

      <h2>
        3. Verarbeitung personenbezogener Daten beim Besuch unserer Website und
        Nutzung der Anwendung
      </h2>

      <h3>a) Hosting über Hetzner Cloud</h3>
      <p>
        Unsere Website und die dazugehörige Anwendung werden bei der Hetzner
        Online GmbH, Industriestr. 25, 91710 Gunzenhausen, Deutschland
        (nachfolgend „Hetzner“) gehostet. Die Server befinden sich in
        Deutschland innerhalb der Europäischen Union.
      </p>
      <p>
        Wenn Sie unsere Website besuchen, erhebt Hetzner im Rahmen des Hostings
        Daten über jeden Zugriff auf den Server (sogenannte Serverlogfiles).
        Diese können Ihre IP-Adresse, den Zeitpunkt des Zugriffs, die
        aufgerufene URL, den Browsertyp und das Betriebssystem umfassen. Dies
        ist technisch erforderlich, um Ihnen die Website anzuzeigen und die
        Stabilität und Sicherheit des Hostings zu gewährleisten. Rechtsgrundlage
        für das Hosting und die damit verbundene kurzzeitige Speicherung der
        IP-Adresse ist unser berechtigtes Interesse an einer sicheren und
        effizienten Bereitstellung unseres Online-Angebots gemäß Art. 6 Abs. 1
        lit. f DSGVO.
      </p>

      <h3>b) Server-Logfiles (Anwendungs-Logging)</h3>
      <p>
        Zusätzlich zu den Hosting-Logs protokollieren wir auf unserem Server
        bestimmte Ereignisse und Zugriffe innerhalb der Anwendung zur
        Sicherstellung des technischen Betriebs, zur Fehleranalyse und zur
        Abwehr von Angriffen. Diese Protokolle können technische Daten wie
        Anfragen an die API, Zeitstempel, Statuscodes und möglicherweise die
        IP-Adresse des anfragenden Systems sowie die Kennung des eingeloggten
        Benutzers enthalten.
      </p>
      <p>
        Rechtsgrundlage ist unser berechtigtes Interesse an einem sicheren,
        stabilen und funktionsfähigen Betrieb der Anwendung (Art. 6 Abs. 1 lit.
        f DSGVO).
      </p>
      <p>
        Diese anwendungsspezifischen Logfiles werden für einen begrenzten
        Zeitraum von maximal 6 Monaten gespeichert und anschließend automatisch
        gelöscht oder anonymisiert, sofern sie nicht zur Aufklärung oder
        Verfolgung von Rechtsverstößen oder Sicherheitsvorfällen länger benötigt
        werden.
      </p>

      <h3>c) Cookies und Local Storage (Technisch notwendig)</h3>
      <p>
        Wir setzen auf unserer Website{" "}
        <strong>ausschließlich technisch notwendige</strong> Cookies und
        Speichertechnologien ein, die für den grundlegenden Betrieb und die
        Kernfunktionalitäten der Anwendung erforderlich sind. Wir verwenden{" "}
        <strong>keine</strong> Cookies für Marketing-, Analyse- oder
        Trackingzwecke Dritter.
      </p>
      <ul>
        <li>
          <strong>Session-Cookie:</strong> Wenn Sie sich anmelden, setzt unser
          Server ein sogenanntes Session-Cookie (z.B. `connect.sid`). Dieses
          Cookie speichert eine zufällige Kennung, um Ihren Browser während
          Ihres Besuchs wiederzuerkennen und Ihnen den Zugriff auf Ihren Account
          zu ermöglichen, ohne dass Sie sich auf jeder Seite neu anmelden
          müssen. Dieses Cookie ist für die Login-Funktionalität unerlässlich
          und wird automatisch gelöscht, wenn Sie Ihren Browser schließen.
        </li>
        <li>
          <strong>Local Storage (JWT):</strong> Nach erfolgreicher Anmeldung
          speichern wir ein JSON Web Token (JWT) im Local Storage Ihres
          Browsers. Dieses Token dient dazu, Sie bei nachfolgenden API-Anfragen
          als angemeldet zu identifizieren, ohne dass Ihre Zugangsdaten erneut
          übertragen werden müssen. Die Daten im Local Storage bleiben
          gespeichert, bis Sie sich aktiv ausloggen oder den Local Storage Ihres
          Browsers manuell löschen.
        </li>
      </ul>
      <p>
        Die Rechtsgrundlage für die Verwendung dieser technisch notwendigen
        Cookies und des Local Storage ist die Erfüllung unseres Vertrags mit
        Ihnen zur Bereitstellung der Nutzerkonto-Funktionen (Art. 6 Abs. 1 lit.
        b DSGVO) sowie unser berechtigtes Interesse an der Bereitstellung einer
        nutzerfreundlichen und funktionsfähigen Anwendung (Art. 6 Abs. 1 lit. f
        DSGVO). In Deutschland ist zusätzlich § 25 Abs. 2 TTDSG relevant.
      </p>

      <h3>d) Nutzung von Cloudflare (CDN und Sicherheit)</h3>
      <p>
        Wir nutzen Dienste der Cloudflare, Inc., 101 Townsend St, San
        Francisco, CA 94107, USA (nachfolgend „Cloudflare“). Cloudflare bietet
        ein Content Delivery Network (CDN) zur schnelleren Auslieferung unserer
        Website-Inhalte und verschiedene Sicherheitsfunktionen (z.B.
        DDoS-Schutz, Web Application Firewall).
      </p>
      <p>
        Wenn Sie unsere Website aufrufen, werden Ihre Anfragen über die Server
        von Cloudflare geleitet. Dabei verarbeitet Cloudflare zwangsläufig Ihre
        IP-Adresse und weitere technische Logdaten (ähnlich wie bei
        Server-Logfiles), um die Dienste bereitzustellen, die Sicherheit zu
        gewährleisten und Angriffe erkennen zu können. Cloudflare kann auch
        technisch notwendige Cookies setzen, die ausschließlich für die
        Sicherheitsfunktionen erforderlich sind (z.B. zur Unterscheidung
        vertrauenswürdiger Besucher).
      </p>
      <p>
        Der Einsatz von Cloudflare erfolgt im Interesse einer erhöhten
        Sicherheit, Verfügbarkeit und einer schnelleren Ladezeit unserer Website
        (berechtigtes Interesse gemäß Art. 6 Abs. 1 lit. f DSGVO).
      </p>
      <p>
        Da Cloudflare ein US-Unternehmen ist, erfolgt eine Datenübertragung in
        die USA. Cloudflare hat sich zur Einhaltung europäischer
        Datenschutzstandards verpflichtet, was durch den Abschluss von
        Standardvertragsklauseln (SCCs) der EU-Kommission gewährleistet wird.
      </p>
      <p>
        Weitere Informationen zum Datenschutz bei Cloudflare finden Sie unter:{" "}
        <a
          href="https://www.cloudflare.com/privacypolicy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.cloudflare.com/privacypolicy/
        </a>
      </p>

      <h2>4. Registrierung und Benutzerkonto</h2>
      <p>
        Sie können sich in unserer Anwendung registrieren, um die
        Law-AI-Funktionen zu nutzen. Die Registrierung neuer Benutzer erfolgt
        ausschließlich durch einen Administrator. Bei der Erstellung eines
        Benutzerkontos durch den Administrator werden folgende Daten erhoben und
        gespeichert:
      </p>
      <ul>
        <li>Benutzername</li>
        <li>E-Mail-Adresse</li>
        <li>Vorname, Nachname</li>
        <li>
          Ein initiales Passwort (wird verschlüsselt als Hash gespeichert; der
          Benutzer sollte es beim ersten Login ändern)
        </li>
        <li>Rolle (Benutzer oder Administrator)</li>
        <li>Aktivierungsstatus</li>
      </ul>
      <p>
        Diese Daten werden zur Erstellung und Verwaltung Ihres Benutzerkontos
        sowie zur Bereitstellung der Dienste im Rahmen der Anwendung benötigt.
        Rechtsgrundlage für die Verarbeitung ist die Erfüllung des
        Nutzungsvertrags (Art. 6 Abs. 1 lit. b DSGVO).
      </p>
      <p>
        Ihre Kontodaten werden gespeichert, solange Ihr Benutzerkonto aktiv ist.
        Sie können die Löschung Ihres Kontos jederzeit beantragen, indem Sie uns
        unter der oben genannten E-Mail-Adresse (jk@phoenixconsulting.at)
        kontaktieren. Im Falle einer Löschung werden Ihre personenbezogenen
        Daten vorbehaltlich gesetzlicher Aufbewahrungspflichten gelöscht.
      </p>

      <h2>5. Nutzung der Law-AI Funktionen (Chat und Analyse)</h2>
      <p>
        Wenn Sie die Chat- und Analysefunktionen unserer Anwendung nutzen,
        verarbeiten wir die von Ihnen eingegebenen Daten (z.B. Chatnachrichten,
        Themen für die Analyse, ausgewählte Gesetze) sowie die von der KI
        generierten Ergebnisse (Analysen, Synthesen). Diese Daten werden in
        unserer Datenbank gespeichert und sind Ihrem Benutzerkonto zugeordnet.
      </p>

      <h3>a) Verarbeitung durch Gemini API (Google)</h3>
      <p>
        Zur Durchführung der Rechtsanalysen und zur Generierung von Antworten im
        Chat nutzen wir die Gemini API von Google (Google Ireland Limited,
        Gordon House, Barrow Street, Dublin 4, Irland bzw. Google LLC, 1600
        Amphitheatre Parkway, Mountain View, CA 94043, USA).
      </p>
      <p>
        Hierfür werden die von Ihnen eingegebenen Inhalte (z.B. das
        Analysethema, der bisherige Chatverlauf, ausgewählte Gesetze,
        Referenzanfragen) an die Server von Google übertragen. Google verarbeitet
        diese Daten ausschließlich zur Erbringung des Dienstes, d.h. um die
        angeforderte Analyse oder Antwort zu generieren und an uns
        zurückzusenden.
      </p>
      <p>
        <strong>Wichtiger Hinweis:</strong> Die an Google übermittelten Daten
        können potenziell sensible Informationen enthalten, je nachdem, was Sie
        eingeben. Wir ergreifen keine automatisierten Maßnahmen zur
        Pseudonymisierung oder Anonymisierung der an die Gemini API gesendeten
        Inhalte vor der Übermittlung. Die Verarbeitung durch Google erfolgt
        gemäß deren Datenschutzbestimmungen und Nutzungsbedingungen für die API.
        Google nutzt die über die API übermittelten Daten nach eigenen Angaben
        nicht zum Training seiner Modelle oder für andere Zwecke als die
        Bereitstellung des API-Dienstes.
      </p>
      <p>
        Rechtsgrundlage für die Übermittlung und Verarbeitung der Daten durch
        die Gemini API ist die Erfüllung unseres Nutzungsvertrags mit Ihnen, da
        diese Verarbeitung zur Bereitstellung der Kernfunktionalität der
        Law-AI-Anwendung erforderlich ist (Art. 6 Abs. 1 lit. b DSGVO).
      </p>
      <p>
        Da Google ein globales Unternehmen ist, können Ihre Daten auch auf
        Servern außerhalb der Europäischen Union (insbesondere in den USA)
        verarbeitet werden. Google sichert die Einhaltung europäischer
        Datenschutzstandards in der Regel durch Standardvertragsklauseln (SCCs)
        der EU-Kommission ab. Weitere Informationen zum Datenschutz bei Google
        Cloud und der Gemini API finden Sie unter:{" "}
        <a
          href="https://cloud.google.com/terms/data-processing-addendum"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://cloud.google.com/terms/data-processing-addendum
        </a>{" "}
        und den spezifischen API-Dokumentationen.
      </p>

      <h3>b) Speicherung von Chats und Analysen</h3>
      <p>
        Die von Ihnen geführten Chats, einschließlich der eingegebenen Fragen,
        der durchgeführten Analysen und der von der KI generierten Antworten und
        Synthesen, werden in unserer Datenbank gespeichert und sind Ihrem
        Benutzerkonto zugeordnet. Dies dient dazu, Ihnen den Zugriff auf Ihre
        bisherigen Interaktionen und Ergebnisse zu ermöglichen.
      </p>
      <p>
        Rechtsgrundlage für die Speicherung ist die Erfüllung des
        Nutzungsvertrags (Art. 6 Abs. 1 lit. b DSGVO).
      </p>

      <h2>6. Speicherdauer und Löschung</h2>
      <p>
        Wir speichern Ihre personenbezogenen Daten nur so lange, wie es für die
        jeweiligen Zwecke, für die sie verarbeitet werden, erforderlich ist oder
        wie es gesetzliche Aufbewahrungsfristen vorschreiben. Grundsätzlich
        werden alle personenbezogenen Daten maximal 6 Monate nach ihrer Erhebung
        bzw. nach der letzten relevanten Aktivität (z.B. letzter Login, letzte
        Chat-Nachricht) gelöscht, sofern keine zwingenden gesetzlichen Gründe
        eine längere Aufbewahrung erfordern.
      </p>
      <ul>
        <li>
          <strong>Benutzerkonten:</strong> Daten bleiben gespeichert, solange
          das Konto aktiv ist, jedoch maximal 6 Monate nach dem letzten Login.
          Auf Antrag werden Konten früher gelöscht.
        </li>
        <li>
          <strong>Chatverläufe und Analysedaten:</strong> Diese Daten werden
          maximal 6 Monate nach der letzten Interaktion im jeweiligen Chat
          gespeichert und anschließend gelöscht.
        </li>
        <li>
          <strong>Server-Logfiles (Hosting & Anwendung):</strong> Werden maximal
          6 Monate gespeichert und dann gelöscht/anonymisiert.
        </li>
      </ul>
      <p>
        Nach Ablauf der jeweiligen Speicherfrist bzw. nach Wegfall des Zwecks
        werden die Daten routinemäßig gesperrt oder gelöscht, sofern keine
        gesetzlichen Aufbewahrungspflichten entgegenstehen.
      </p>

      <h2>7. Datensicherheit</h2>
      <p>
        Wir treffen technische und organisatorische Sicherheitsmaßnahmen, um
        Ihre personenbezogenen Daten gegen unbeabsichtigte oder unrechtmäßige
        Löschung, Veränderung oder gegen Verlust und gegen unberechtigte
        Weitergabe oder unberechtigten Zugriff zu schützen. Dazu gehören unter
        anderem die Verschlüsselung der Kommunikation (HTTPS) und die
        verschlüsselte Speicherung von Passwörtern (Hashing).
      </p>

      <h2>8. Änderungen dieser Datenschutzerklärung</h2>
      <p>
        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie
        stets den aktuellen rechtlichen Anforderungen entspricht oder um
        Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen,
        z.B. bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt
        dann die neue Datenschutzerklärung.
      </p>
    </LegalPageContainer>
  );
};

export default DatenschutzPage;
